import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Input,  Row, Select} from 'antd';
import { SPAN_FULL, SPAN_ONE_THIRD, MARGIN_SM, MARGIN_MD } from '../../../../../../../styles/constants';
import { showFileMappingWizardAddFieldFunctionSubstrFormChange, onClearSubsrt } from '../../actions';
import _ from "lodash";

const mapStateToProps = state => ({
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
  SubstrFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.SubstrFormData
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(showFileMappingWizardAddFieldFunctionSubstrFormChange(fields)),
  onClearSubsrt: () => dispatch(onClearSubsrt()),
});

const mapPropsToFields = ({SubstrFormData}) => ({
  startValue: Form.createFormField({value: SubstrFormData !== null ? SubstrFormData.startValue : null}),
  lenghtValue: Form.createFormField({value: SubstrFormData !== null ? SubstrFormData.lenghtValue : null}),
  selectValue: Form.createFormField({value: SubstrFormData !== null ? SubstrFormData.selectValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardSubstrWizard = ({
                                                t,
                                                form,
                                                mergedHeader,
                                                onClearSubsrt
                                              }) => {
                          
  return (
    
    <Fragment>
        <Col span={SPAN_FULL}>
          <Row type='flex' justify='space-between'>
            <Col span={SPAN_ONE_THIRD}>
              <Form.Item
                className="form-item"
                label={t('data.fileMapping.addField.functionWizard.field.label')}
              >
                {form.getFieldDecorator("selectValue")(
                  <Select
                    title={form.getFieldValue("selectValue")}
                    >
                    {mergedHeader.map((field) => (
                      <Select.Option
                        key={field.name}
                        value={field.name}
                        title={`${field.name}`}
                      >
                        {field.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Row type='flex'>
                <Form.Item
                  className='form-item'
                  label={t('data.fileMapping.addField.functionWizard.start.label')}
                  style={{marginRight: MARGIN_SM}}
                  >
                    {form.getFieldDecorator("startValue")(
                      <Input
                        onKeyPress={(event) => {
                          if (!/[-]?[0-9]*/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        title={form.getFieldValue("startValue")}
                        style={{
                          width: 50
                        }}
                      />
                    )}
                </Form.Item>
                <Form.Item
                  className='form-item'
                  label={t('data.fileMapping.addField.functionWizard.lenght.label')}
                  >
                    {form.getFieldDecorator("lenghtValue")(
                      <Input
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        title={form.getFieldValue("lenghtValue")}
                        style={{
                          width: 50,
                          marginLeft: {MARGIN_MD}
                        }}
                      />
                    )}
                </Form.Item>
              </Row>
            </Col>
            <Col>
              <Button
                onClick={onClearSubsrt}
                icon="delete"
              >
              </Button>
            </Col>
          </Row>
        </Col>
    </Fragment>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardSubstrWizard);